import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/Bluearrow.png'
import _imports_1 from '../../assets/zhuXTlogo.png'
import _imports_2 from '../../assets/rightArrow.png'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "item start-address" }
const _hoisted_3 = { class: "item end-address" }
const _hoisted_4 = { class: "footer" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "btns" }

import {
    computed,
    type CSSProperties,
    type ComputedRef,
  } from 'vue';
  import { useRouter } from 'vue-router';

  interface Item {
    id: string | number;
    name?: string;
    startProvince?: string;
    startCity?: string;
    endProvince?: string;
    endCity?: string;
    carrier?: string;
    carriertype?: string;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ZltContainer',
  props: {
    width: { default: 434 },
    url: {},
    ptype1: {},
    item: { default: () => ({}) as Item }
  },
  setup(__props: any) {

  const router = useRouter();

  // 定义props类型,接收数据
  const props = __props;

  const styles: ComputedRef<CSSProperties> = computed(() => {
    return {
      width: props.width + 'px',
    };
  });

  const handleViewDetail = () => {
    props.url && router.push(props.url);
  };

  const baojie = () => {
    alert('包接');
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "zlt-container",
    style: _normalizeStyle(styles.value),
    onClick: handleViewDetail
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.item.startProvince) + " " + _toDisplayString(_ctx.item.startCity), 1),
      _cache[0] || (_cache[0] = _createElementVNode("img", {
        src: _imports_0,
        alt: "",
        class: "arrow-icon"
      }, null, -1)),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.item.endProvince) + " " + _toDisplayString(_ctx.item.endCity), 1)
    ]),
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.item.carriertype) + " " + _toDisplayString(_ctx.item.carrier), 1),
      _cache[2] || (_cache[2] = _createElementVNode("img", {
        src: _imports_1,
        class: "logo",
        alt: ""
      }, null, -1)),
      _cache[3] || (_cache[3] = _createElementVNode("img", {
        src: _imports_2,
        alt: "",
        class: "arrow-icon"
      }, null, -1)),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "btn",
          onClick: _withModifiers(baojie, ["stop"])
        }, "包接"),
        _cache[1] || (_cache[1] = _createElementVNode("button", { class: "btn" }, "包送", -1))
      ])
    ]),
    _renderSlot(_ctx.$slots, "footer")
  ], 4))
}
}

})